module.exports = __webpack_public_path__ + "img/milestone__08.1b96eed6.jpg";